import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
//import Table from "./Table";
import axios from "axios";
import Table from "./LeaseListingTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronRight,
  faEye,
  faPen,
  faPlus,
  faSave,
  faTimes,
  faUndo,
} from "@fortawesome/free-solid-svg-icons";
//import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
//import styles from "../../masters/master.css";
import apiUrl from "../../apiUrlConstant";
//import CreatableSelect from "react-select/creatable";
import { Redirect, withRouter, Link } from "react-router-dom";
import Popup from "reactjs-popup";
import { PopupMessage } from "../../utils/utils";
//import Select from "react-select";

import Select, {
  components,
  MultiValueGenericProps,
  MultiValueProps,
  OnChangeValue,
  Props,
} from "react-select";

import * as Yup from "yup";
import { type } from "jquery";
import { getUserType, fileUploadPath } from "../../utils/index";

if (getUserType() == "Landlord") {
  var reportFilterForm = Yup.object().shape({
    // assetId: Yup.string().required("Required"),
    leaseId: Yup.string().required("Required"),
    financialYear: Yup.string().required("Required"),
    dataUomId: Yup.string().required("Required"),
    //stateId: Yup.string().required("Required"),
    //districtId: Yup.string().required("Required"),
    //cityId: Yup.string().required("Required"),
  });
} else if (getUserType() == "Occupier") {
  var reportFilterForm = Yup.object().shape({
    // fbrandId: Yup.number().required("Required"),
    leaseId: Yup.string().required("Required"),
    financialYear: Yup.string().required("Required"),
    dataUomId: Yup.string().required("Required"),
    // stateId: Yup.string().required("Required"),
    // districtId: Yup.string().required("Required"),
    // cityId: Yup.string().required("Required"),
  });
} else {
  var reportFilterForm = Yup.object().shape({
    leaseId: Yup.string().required("Required"),
    financialYear: Yup.string().required("Required"),
    dataUomId: Yup.string().required("Required"),
  });
}

// const reportFilterForm = Yup.object().shape({
//   countryId: Yup.string().required("Required"),
//   stateId: Yup.string().required("Required"),
//   districtId: Yup.string().required("Required"),
//   cityId: Yup.string().required("Required"),
//   leaseId: Yup.string().required("Required"),
//   financialYear: Yup.string().required("Required"),
//   dataUomId: Yup.string().required("Required"),
// });

const uploadFromFrm = Yup.object().shape({
  myfile: Yup.string().required("Required"),
});

let monthsArr = [];
var i = 0;
for (; i <= 12; i++) {
  monthsArr.push({ id: i, value: i });
}

const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};

let financialYear = [];
// var i = 0;  let currentYear = new Date().getFullYear();
// financialYear.push({ id: (currentYear + 1) , value: (currentYear )  + "-" + (currentYear + 1) })
// for (; i <= 10; i++) {
//   financialYear.push({ id: currentYear , value: (currentYear - 1)  + "-" + currentYear });
//   --currentYear;
// }

class LeaseReportSalesActual extends React.Component {
  groupId = { value: "" };
  state = {
    brandSelected: [],
    countries: [],
    districtList: [],
    cityList: [],
    brandCatList: [],
    brandList: [],
    financialYear: [],
    exportBtn: false,
    assetsList: [],
    assetTypeList: [],
    assetTypeSelected: [],
    redirect: false,
    messsagePopup: false,
    popupContent: "Data Saved Successfully!",
    popupalertMessage: false,
    popupMessageContent: '',
    states: [],

    id: undefined,
    selectedBrand: "",
    counter: 0,
    selectedAsset: "",

    leaseList: [],
    formResponseData: {
      forecasteDetails: {
        forecast: [],
        actual: [],
      },
    },
    initialForecast: {},
    leaseTypes: [],
    initialValues: {
      brandId: [],
      countryId: "",
      stateId: "",
      districtId: "",
      cityId: "",
      brandCatId: "",
      brandName: [],
      leaseId: "",
      financialYear: "",
      dataUomId: "Per Month",
      dataUOMName: "Per Month",
      modelValue: 'All',
      modelId: 'All',
      assetTypeId: "",
    },
  };

  componentDidMount() {
    this.initialiseAllData();
  }

  componentDidUpdate() { }

  constructor(props) {
    super(props);
  }

  initialiseAllData = () => {
    fetch(`${apiUrl.apiUrl.url}/countries`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          countries: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`${apiUrl.apiUrl.url}/brand/get-all-brands`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          brandList: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`${apiUrl.apiUrl.url}/lease-report/get-lease-status`, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("data", data);
        this.setState({
          leaseStatus: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });


    fetch(`${apiUrl.apiUrl.url}/lease-report/fetch-lease-types`, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("data", data);
        this.setState({
          leaseTypes: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    this.getAssetsList("", "", true);
    this.getAssetTypes();
  }

  getAssetTypes = () => {
    let self = this;
    axios({
      method: 'GET',
      url: `${apiUrl.apiUrl.url}/unit-detail/get-asset-types-with-filters?city_id=${this.state.initialValues.cityId}&brand_ids=${this.state.initialValues.brandId}
      `,
      headers: headers
    }).then((response) => {
      self.setState({
        assetTypeList: response.data
      });
    });
  }

  getAssetsListByAssetType = () => {
    var headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("TOKEN"),
    };

    fetch(
      `${apiUrl.apiUrl.url}/unit-detail/get-asset-types-asset-lists?asset_type_ids=
      ${this.state.initialValues.assetTypeId}&city_id=${this.state.initialValues.cityId}&brand_ids=${this.state.initialValues.brandId}`,
      { headers }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("data", data);
        this.setState({
          assetsList: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getAssetsList = (input, e, cust) => {
    if (
      (typeof e != "undefined" && e.action == "input-change") ||
      cust === true
    ) {
      fetch(
        `${apiUrl.apiUrl.url}/unit-detail/get-all-assets?city_id=` +
        this.state.initialValues.cityId +
        `&assetName=` +
        input,
        { headers }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          console.log("data", data);
          this.setState({
            assetsList: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  setMasterPreValues = (input) => {
    fetch(
      `${apiUrl.apiUrl.url}/unit-detail/get-select-asset-details?assetId=` +
      input,
      { headers }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          countries: data.countries,
          districtList: data.district,
          states: data.state,
          cityList: data.cities,
        });
        this.state.initialValues.stateId = data.data.stateId.stateId;
        this.state.initialValues.state_name = data.data.stateId.state_name;
        this.state.initialValues.cityId = data.data.cityId.cityId;
        this.state.initialValues.cityName = data.data.cityId.cityName;
        this.state.initialValues.districtId = data.data.districtId.districtId;
        this.state.initialValues.districtName =
          data.data.districtId.districtName;
        this.state.initialValues.countryId = data.data.countryId.countryId;
        this.state.initialValues.countryName = data.data.countryId.countryName;
        if (
          this.state.initialValues.brandId.length == 0 ||
          this.state.initialValues.brandId == ""
        ) {
          this.state.initialValues.brandCatId = data.data.catId;
          this.state.initialValues.brandCatName = data.data.cat_name;
          this.state.brandList = data.brandList;
          this.state.brandSelected = [
            { value: data.data.brandId, label: data.data.brand_name },
          ];
          // this.state.initialValues.brandId = [data.data.brandId];
        }
        this.setState({});
      })
      .catch((error) => {
        console.log(error);
      });
  };

  valueChange = (newValue, actionMeta) => {
    console.log("newVa calling..", newValue, "meta", actionMeta);

    //newValue.value = newValue.target.value;
    //newValue.label = newValue.target.value;

    if (actionMeta == "change_state") {
      this.state.initialValues.stateId = newValue.value;
      this.state.initialValues.state_name = newValue.label;

      this.state.initialValues.districtId = "";
      this.state.initialValues.districtName = "";
      this.state.initialValues.cityId = "";
      this.state.initialValues.cityName = "";

      this.state.initialValues.assetId = "";
      this.state.initialValues.assetName = "";

      fetch(
        `${apiUrl.apiUrl.url}/district/state-districts?state_id=` +
        newValue.value
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            districtList: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });

      //districtList
    } else if (actionMeta == "change_district") {
      this.state.initialValues.districtId = newValue.value;
      this.state.initialValues.districtName = newValue.label;

      this.state.initialValues.cityId = "";
      this.state.initialValues.cityName = "";

      fetch(`${apiUrl.apiUrl.url}/cities/district-cities/` + newValue.value, {headers})
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            cityList: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (actionMeta == "change_lease_type") {
      this.state.initialValues.modelId = newValue.value;
      this.state.initialValues.modelValue = newValue.label;

      fetch(
        `${apiUrl.apiUrl.url}/lease-view/get-lease-list?brand=` +
        this.state.initialValues.brandId +
        "&asset=" +
        this.state.initialValues.assetId +
        "&brandCategory=" +
        this.state.initialValues.brandCatId + "&modelType=" + this.state.initialValues.modelId,
        { headers }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            leaseList: data,
          });

          this.state.initialValues.leaseValue = "";
          this.state.initialValues.leaseId = "";
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (actionMeta == "change_lease_number") {
      //change_document_type
      this.state.initialValues.leaseId = newValue.value;
      this.state.initialValues.leaseValue = newValue.label;

      this.state.leaseList.forEach((item) => {
        if (newValue.value == item.id) {
          this.state.initialValues.assetId = item.asset_id;
          this.state.initialValues.assetName = item.asset_name;

          this.setMasterPreValues(item.asset_id);
        }
      });

      fetch(
        `${apiUrl.apiUrl.url}/lease-view/get-lease-financial-years?leaseId=` +
        newValue.value, { headers }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            financialYear: data.fianancialYears,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (actionMeta == "brand_category") {
      this.state.initialValues.brandCatId = newValue.value;
      this.state.initialValues.brandCatName = newValue.label;
      this.state.initialValues.brandId = [];
      this.state.initialValues.brandName = [];
      //get-brand-subcategory/?id=
      fetch(
        `${apiUrl.apiUrl.url}/brand/get-brand-by-category?cat_id=` +
        newValue.value,
        { headers }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            brandList: data,
          });

          this.state.brandSelected = [];
          this.state.initialValues.brandId = ["0"];
          this.state.brandSelected.push({ value: 0, label: "All" });

          for (let i = 0; i < data.length; i++) {
            this.state.initialValues.brandId.push(data[i].id);
          }

          console.log(
            this.state.initialValues.brandId,
            "this.state.initialValues.brandId"
          );
          this.setState({});

          this.getAssetsListByBrand();
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (actionMeta == "change_city") {

      // unset asset type and asset name
      this.state.brandSelected = [];
      this.state.initialValues.brandId = [];
      this.state.assetTypeSelected = [];
      this.state.initialValues.assetTypeId = [];
      this.state.assetsList = [];
      this.state.initialValues.assetName ="";
      this.state.initialValues.assetId ="";
      this.getAssetTypes();

      //brandName
      this.state.initialValues.cityId = newValue.value;
      this.state.initialValues.cityName = newValue.label;

      fetch(
        `${apiUrl.apiUrl.url}/unit-detail/get-all-assets?city_id=` +
        newValue.value,
        { headers }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          console.log("data", data);
          this.setState({
            assetsList: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });

    } else if (actionMeta == "change_lease_status") {
      //brandName
      this.state.initialValues.LeaseStatusId = newValue.value;
      this.state.initialValues.LeaseStatusName = newValue.label;
    } else if (actionMeta == "change_brand") {

      // unset asset type and asset name
      this.state.assetTypeSelected = [];
      this.state.initialValues.assetTypeId = [];
      this.state.assetsList = [];
      this.state.initialValues.assetName ="";
      this.state.initialValues.assetId ="";

      this.state.brandSelected = [];
      this.state.initialValues.brandId = [];
      for (let i = 0; i < newValue.length; i++) {
        this.state.initialValues.brandId.push(newValue[i].value);
        this.state.brandSelected.push({
          value: newValue[i].value,
          label: newValue[i].label,
        });
      }
      this.getAssetsListByBrand();
      this.getAssetTypes();

      fetch(
        `${apiUrl.apiUrl.url}/lease-view/get-lease-list?brand=` +
        this.state.initialValues.brandId +
        "&asset=" +
        this.state.initialValues.assetId +
        "&brandCategory=" +
        this.state.initialValues.brandCatId + "&modelType=" + this.state.initialValues.modelId,
        { headers }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            leaseList: data,
          });

          this.state.initialValues.leaseValue = "";
          this.state.initialValues.leaseId = "";
        })
        .catch((error) => {
          console.log(error);
        });

      console.log(this.state.initialValues, "this.state.initialValues");
    } else if (actionMeta == "change_asset_type") {

      this.state.initialValues.assetName ="";
      this.state.initialValues.assetId ="";

      this.state.assetTypeSelected = [];
      this.state.initialValues.assetTypeId = [];
      for (let i = 0; i < newValue.length; i++) {
        this.state.initialValues.assetTypeId.push(newValue[i].value);
        this.state.assetTypeSelected.push({
          value: newValue[i].value,
          label: newValue[i].label,
        });
      }

      this.getAssetsListByAssetType();

    } else if (actionMeta == "change_asset_name") {
      //change_lease_month
      this.state.initialValues.assetId = newValue.value;
      this.state.initialValues.assetName = newValue.label;
      this.setMasterPreValues(newValue.value);
      fetch(
        `${apiUrl.apiUrl.url}/lease-view/get-lease-list?brand=` +
        this.state.initialValues.brandId +
        "&asset=" +
        this.state.initialValues.assetId +
        "&brandCategory=" +
        this.state.initialValues.brandCatId + "&modelType=" + this.state.initialValues.modelId,
        { headers }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            leaseList: data,
          });

          this.state.initialValues.leaseValue = "";
          this.state.initialValues.leaseId = "";
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (actionMeta == "change_uom") {
      //change_lease_month
      this.state.initialValues.dataUomId = newValue.value;
      this.state.initialValues.dataUOMName = newValue.label;

      console.log(this.state.initialValues, "initial valuyes");
    } else if (actionMeta == "change_financial_year") {
      //change_lease_month
      this.state.initialValues.financialYearId = newValue.value;
      this.state.initialValues.financialYear = newValue.label;
    } else if (actionMeta == "change_lease_month") {
      //change_lease_month
      this.state.initialValues.leaseMonthId = newValue.value;
      this.state.initialValues.leaseMonthId = newValue.label;
    } else {
      this.state.initialValues.countryId = newValue.value;
      this.state.initialValues.countryName = newValue.label;
    }
    this.setState({});
  };
  getAssetsListByBrand = () => {
    var headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("TOKEN"),
    };

    fetch(
      `${apiUrl.apiUrl.url}/unit-detail/get-brand-asset-list?brandId=` +
      this.state.initialValues.brandId,
      { headers }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("data", data);
        this.setState({
          assetsList: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(
      `${apiUrl.apiUrl.url}/lease-view/get-lease-list?brand=` +
      this.state.initialValues.brandId +
      "&asset=" +
      this.state.initialValues.assetId +
      "&brandCategory=" +
      this.state.initialValues.brandCatId + "&modelType=" + this.state.initialValues.modelId,
      { headers }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          leaseList: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };
  handleChangeCountry = (newValue, actionMeta) => {
    console.log(newValue.value, "jj");
    this.countryId = newValue.value;
    newValue.label = newValue.label;

    if (newValue.value == "") {
      console.log("country value empty");
      this.state.states = [];
    }

    this.state.initialValues.countryId = newValue.value;
    this.state.initialValues.countryName = newValue.label;

    this.state.initialValues.stateId = "";
    this.state.initialValues.stateName = "";
    this.state.initialValues.districtId = "";
    this.state.initialValues.districtName = "";
    this.state.initialValues.cityId = "";
    this.state.initialValues.cityName = "";

    fetch(`${apiUrl.apiUrl.url}/states/country-states/` + this.countryId, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          states: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleChangeClientGroup = (newValue, actionMeta) => {
    console.group("Value Changed", newValue, "actionmeta", actionMeta);
    this.state.initialValues.groupId = newValue.value;
    this.state.initialValues.groupName = newValue.label;
    this.setState({});
    console.log(newValue, "ddd");
    console.log(`action: ${actionMeta}`);
    console.groupEnd();
  };

  onFileChange = (event) => {
    // Update the state
    this.setState({ selectedFile: event.target.files[0] });
  };
  // On file upload (click the upload button)
  onFileUpload = () => {
    // Create an object of formData
    const formData = new FormData();

    console.log(formData, "formData");

    if (typeof this.state.selectedFile == "undefined") {
      // alert("Please upload file to process");
      this.setState({
        popupalertMessage: true,
        popupMessageContent: 'Please upload file to process',
      });
      return true;
    }

    var ths = this;

    // Update the formData object
    formData.append(
      "myFile",
      this.state.selectedFile,
      this.state.selectedFile.name
    );
    formData.append("dateAsOn", this.state.initialValues.dateAsOn);
    formData.append("leaseId", this.state.initialForecast.leaseId);
    formData.append("type", "actual");

    // Request made to the backend api
    // Send formData object
    axios
      .post(`${apiUrl.apiUrl.url}/sales-input/import-forecast`, formData)
      .then(function (response) {
        console.log(response, "response");
        if (response.data.success) {
          ths.setState({ redirect: true });
          ths.state.brandSelected = [];
          ths.state.leaseSelected = [];

          // alert("Form processed successfully.");
          ths.setState({
            popupalertMessage: true,
            popupMessageContent: 'Form processed successfully.',
          });
          for (const [key, value] of Object.entries(ths.state.initialValues)) {
            ths.state.initialValues[key] = "";
          }
          ths.setState({
            formResponseData: {
              forecasteDetails: {
                forecast: [],
                actual: [],
              },
            },
            initialForecast: [],
            exportBtn: false,
          });
          ths.setState({});
        }
      });
  };
  redirectAfterSave = () => {
    this.setState({ redirect: true, messsagePopup: false, });
  };

  redirectToClose = () => {
    this.setState({
      popupalertMessage: false,
      popupMessageContent: '',
    });
  };

  render() {
    if (this.state.redirect == true) {
      let url = this.props.match;

      this.state.redirect = false;
      return <Redirect push to="/reports/lease-report-sales-actual" />;
    }
    return (
      <div className="parentContainer">
        {this.renderForm()}
      </div>
    );
  }

  renderForm() {
    return (
      <div>
        <div className="absoluteItemForTopBar">
          <div className="new_breadcrumbs_design">
            <ul className="d-flex align-items-center gap-3 p-0 m-0">
              <li>Reports</li>
              <li><FontAwesomeIcon icon={faChevronRight} /></li>
              <li>
                <a href="#">Lease Report - Sales Input - Actual</a>
              </li>
            </ul>
          </div>
        </div>

        <Formik
          initialValues={this.state.initialValues}
          enableReinitialize
          validationSchema={reportFilterForm}
          onReset={(values, actions) => {
            console.log("hii");
            this.state.brandSelected = [];
            for (const [key, value] of Object.entries(
              this.state.initialValues
            )) {
              this.state.initialValues[key] = "";
            }
            this.state.formResponseData.forecasteDetails.actual = [];
            this.setState({ exportBtn: false });
            this.setState({});

            this.state.assetTypeSelected = [];
            this.state.initialValues.assetTypeId = [];
            this.initialiseAllData();
          }}
          onSubmit={(values, actions) => {
            values.groupId = this.state.initialValues.groupId;

            var brand_id = this.state.initialValues.brandId;
            var asset_id = this.state.initialValues.assetId;
            var form_config = this.state.initialValues;

            form_config.expiry_status = true;

            var counter = this.state.counter + 1;
            console.log(counter, "counter");
            this.setState({ counter: counter });

            this.setState({ selectedBrand: brand_id });
            this.setState({ selectedAsset: asset_id });
            this.setState({ formConfig: form_config });
            var prm = Object.entries(form_config)
              .map(([key, val]) => `${key}=${val}`)
              .join("&");
            this.state.formResponseData = [];

            fetch(`${apiUrl.apiUrl.url}/sales-input/fetch-sales-input?` + prm, {headers})
              .then((response) => {
                return response.json();
              })
              .then((data) => {
                //this.setState({  });
                this.setState({
                  formResponseData: data,
                  initialForecast: data.forecasteDetails,
                });

                this.state.initialForecast.leaseId = data.lease_id;
                this.state.initialForecast.year = data.year;

                this.setState({
                  exportBtn: true,
                  exportUrl:
                    `${apiUrl.apiUrl.url}/sales-input/fetch-sales-input?export=true&reportType=actual&` +
                    prm,
                });
              })
              .catch((error) => {
                console.log(error);
              });

            form_config = undefined;
          }}
        >
          {({
            values,

            errors,

            touched,

            handleChange,

            handleBlur,

            handleSubmit,

            isSubmitting,
          }) => (
            <>
              <div className="unitFormContainerNew">
                <Form autoComplete="off">
                  <div className="newGridSectionParent">
                    <div className="newGridSectionForFormMain">
                      <div className="newGridSectionInner">
                        <label>Country</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="countryId"
                            isSearchable="true"
                            onChange={(e) => {
                              this.handleChangeCountry(e, "changecountry");
                            }}
                            value={{
                              label: this.state.initialValues.countryName,
                              value: this.state.initialValues.countryId,
                            }}
                            options={this.state.countries.map((item) => ({
                              label: item.country_name,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage
                            name="countryId"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>Brand Name</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="brandId"
                            isMulti
                            onInputChange={this.handleChange}
                            onChange={(e) => {
                              this.valueChange(e, "change_brand");
                            }}
                            value={this.state.brandSelected}
                            options={this.state.brandList.map((item) => ({
                              label: item.brand_name,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage
                            name="brandId"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>State</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="stateId"
                            onChange={(e) => {
                              this.valueChange(e, "change_state");
                            }}
                            value={{
                              label: this.state.initialValues.state_name,
                              value: this.state.initialValues.state_id,
                            }}
                            options={this.state.states.map((item) => ({
                              label: item.state_name,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage
                            name="stateId"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>Asset Type</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="assetId"
                            isMulti
                            onInputChange={this.handleChange}
                            onChange={(e) => {
                              this.valueChange(e, "change_asset_type");
                            }}
                            value={this.state.assetTypeSelected}
                            options={this.state.assetTypeList.map((item) => ({
                              label: item.name,
                              value: item.id,
                            }))}
                          />
                        </div>
                      </div>

                      

                      <div className="newGridSectionInner">
                        <label>District</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="districtId"
                            onChange={(e) => {
                              this.valueChange(e, "change_district");
                            }}
                            value={{
                              label: this.state.initialValues.districtName,
                              value: this.state.initialValues.districtId,
                            }}
                            options={this.state.districtList.map((item) => ({
                              label: item.district_name,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage
                            name="districtId"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>Asset Name</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="assetId"
                            onInputChange={this.getAssetsList}
                            onChange={(e) => {
                              this.valueChange(e, "change_asset_name");
                            }}
                            value={{
                              label: this.state.initialValues.assetName,
                              value: this.state.initialValues.assetId,
                            }}
                            options={this.state.assetsList.map((item) => ({
                              label: item.asset_name,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage
                            name="assetId"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      

                      <div className="newGridSectionInner">
                        <label>City</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="cityId"
                            onChange={(e) => {
                              this.valueChange(e, "change_city");
                            }}
                            value={{
                              label: this.state.initialValues.cityName,
                              value: this.state.initialValues.cityId,
                            }}
                            options={this.state.cityList.map((item) => ({
                              label: item.city_name,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage
                            name="cityId"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>Model Type</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="leaseId"
                            onChange={(e) => {
                              this.valueChange(e, "change_lease_type");
                            }}
                            value={{
                              label: this.state.initialValues.modelValue,
                              value: this.state.initialValues.modelId,
                            }}
                            options={this.state.leaseTypes.map((item) => ({
                              label: item.value,
                              value: item.label,
                            }))}
                          />
                          <ErrorMessage
                            name="leaseId"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>Lease Number</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="leaseId"
                            onChange={(e) => {
                              this.valueChange(e, "change_lease_number");
                            }}
                            value={{
                              label: this.state.initialValues.leaseValue,
                              value: this.state.initialValues.leaseId,
                            }}
                            options={this.state.leaseList.map((item) => ({
                              label: item.lease_code,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage
                            name="leaseId"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>
                          Financial Year Ending On <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="financialYear"
                            onChange={(e) => {
                              this.valueChange(e, "change_financial_year");
                            }}
                            value={{
                              label: this.state.initialValues.financialYear,
                              value: this.state.initialValues.financialYear,
                            }}
                            options={this.state.financialYear.map((item) => ({
                              label: item.value,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage
                            name="financialYear"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>
                          Data UOM <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            onChange={(e) => {
                              this.valueChange(e, "change_uom");
                            }}
                            value={{
                              label: this.state.initialValues.dataUOMName,
                              value: this.state.initialValues.dataUOMId,
                            }}
                            name="dataUomId"
                            options={["Per Month"].map((item) => ({
                              label: item,
                              value: item,
                            }))}
                          />
                          <ErrorMessage
                            name="dataUomId"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>Cost Center</label>
                        <div className="position-relative">
                          <input
                            className="basic-single"
                            name="costcenter"
                            onChange={(e) => {
                              console.log(e, "");
                              this.state.initialValues.costCenter = e.target.value;
                              this.setState({});
                            }}
                          />
                          <ErrorMessage
                            name="costCenter"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                    </div>
                    <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                      <button type="submit" className="add_button">
                        View
                      </button>
                      <button type="reset" className="reset_button">
                        Reset
                      </button>
                    </div>
                  </div>
                </Form>
              </div>

              {/* <div className="unitFormContainerNew">
                <Form autoComplete="off" >
                  <div className="container">
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Country
                            </label>
                            <div className="col-sm-7">
                              <Select
                                className="basic-single custom-select-style"
                                classNamePrefix="custom-select-style-inner"
                                name="countryId"
                                isSearchable="true"
                                onChange={(e) => {
                                  this.handleChangeCountry(e, "changecountry");
                                }}
                                value={{
                                  label: this.state.initialValues.countryName,
                                  value: this.state.initialValues.countryId,
                                }}
                                options={this.state.countries.map((item) => ({
                                  label: item.country_name,
                                  value: item.id,
                                }))}
                              />

                              <ErrorMessage
                                name="countryId"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Brand Name
                            </label>
                            <div className="col-sm-7">
                              <Select
                                className="basic-single custom-select-style"
                                classNamePrefix="custom-select-style-inner"
                                name="brandId"
                                isMulti
                                //closeMenuOnSelect={false}
                                onInputChange={this.handleChange}
                                // onChange={}
                                onChange={(e) => {
                                  //handleChange(e);
                                  this.valueChange(e, "change_brand");
                                }}
                                value={this.state.brandSelected}
                                options={this.state.brandList.map((item) => ({
                                  label: item.brand_name,
                                  value: item.id,
                                }))}
                              />

                              <ErrorMessage
                                name="brandId"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>

                    <div className="row">
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              State
                            </label>
                            <div className="col-sm-7">
                              <Select
                                className="basic-single custom-select-style"
                                classNamePrefix="custom-select-style-inner"
                                name="stateId"
                                // onInputChange={this.handleChange}
                                // onChange={}
                                onChange={(e) => {
                                  //handleChange(e);
                                  this.valueChange(e, "change_state");
                                }}
                                value={{
                                  label: this.state.initialValues.state_name,
                                  value: this.state.initialValues.state_id,
                                }}
                                options={this.state.states.map((item) => ({
                                  label: item.state_name,
                                  value: item.id,
                                }))}
                              />

                              <ErrorMessage
                                name="stateId"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Asset Name
                            </label>
                            <div className="col-sm-7">
                              <Select
                                className="basic-single custom-select-style"
                                classNamePrefix="custom-select-style-inner"
                                name="assetId"
                                onInputChange={this.getAssetsList}
                                // onInputChange={this.handleChange}
                                // onChange={}
                                onChange={(e) => {
                                  //handleChange(e);
                                  this.valueChange(e, "change_asset_name");
                                }}
                                value={{
                                  label: this.state.initialValues.assetName,
                                  value: this.state.initialValues.assetId,
                                }}
                                options={this.state.assetsList.map((item) => ({
                                  label: item.asset_name,
                                  value: item.id,
                                }))}
                              />

                              <ErrorMessage
                                name="assetId"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>

                    <div className="row">
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              District
                            </label>
                            <div className="col-sm-7">
                              <Select
                                className="basic-single custom-select-style"
                                classNamePrefix="custom-select-style-inner"
                                name="districtId"
                                // onInputChange={this.handleChange}
                                // onChange={}
                                onChange={(e) => {
                                  //handleChange(e);
                                  this.valueChange(e, "change_district");
                                }}
                                value={{
                                  label: this.state.initialValues.districtName,
                                  value: this.state.initialValues.districtId,
                                }}
                                options={this.state.districtList.map((item) => ({
                                  label: item.district_name,
                                  value: item.id,
                                }))}
                              />

                              <ErrorMessage
                                name="districtId"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Model Type
                            </label>
                            <div className="col-sm-7">
                              <Select
                                className="basic-single custom-select-style"
                                classNamePrefix="custom-select-style-inner"
                                name="leaseId"
                                // onInputChange={this.handleChange}
                                // onChange={}
                                onChange={(e) => {
                                  //handleChange(e);
                                  this.valueChange(e, "change_lease_type");
                                }}
                                value={{
                                  label: this.state.initialValues.modelValue,
                                  value: this.state.initialValues.modelId,
                                }}
                                options={this.state.leaseTypes.map((item) => ({
                                  label: item.value,
                                  value: item.label,
                                }))}
                              />


                              <ErrorMessage
                                name="leaseId"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>

                    <div className="row">
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              City
                            </label>
                            <div className="col-sm-7">
                              <Select
                                className="basic-single custom-select-style"
                                classNamePrefix="custom-select-style-inner"
                                name="cityId"
                                // onInputChange={this.handleChange}
                                // onChange={}
                                onChange={(e) => {
                                  //handleChange(e);
                                  this.valueChange(e, "change_city");
                                }}
                                value={{
                                  label: this.state.initialValues.cityName,
                                  value: this.state.initialValues.cityId,
                                }}
                                options={this.state.cityList.map((item) => ({
                                  label: item.city_name,
                                  value: item.id,
                                }))}
                              />

                              <ErrorMessage
                                name="cityId"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Lease Number
                            </label>
                            <div className="col-sm-7">
                              <Select
                                className="basic-single custom-select-style"
                                classNamePrefix="custom-select-style-inner"
                                name="leaseId"
                                // onInputChange={this.handleChange}
                                // onChange={}
                                onChange={(e) => {
                                  //handleChange(e);
                                  this.valueChange(e, "change_lease_number");
                                }}
                                value={{
                                  label: this.state.initialValues.leaseValue,
                                  value: this.state.initialValues.leaseId,
                                }}
                                options={this.state.leaseList.map((item) => ({
                                  label: item.lease_code,
                                  value: item.id,
                                }))}
                              />

                              <ErrorMessage
                                name="leaseId"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>

                    <div className="row">

                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Financial Year Ending On{" "}
                              <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Select
                                className="basic-single custom-select-style"
                                classNamePrefix="custom-select-style-inner"
                                name="financialYear"
                                // onInputChange={this.handleChange}
                                // onChange={}
                                onChange={(e) => {
                                  //handleChange(e);
                                  this.valueChange(e, "change_financial_year");
                                }}
                                value={{
                                  label: this.state.initialValues.financialYear,
                                  value: this.state.initialValues.financialYear,
                                }}
                                options={this.state.financialYear.map((item) => ({
                                  label: item.value,
                                  value: item.id,
                                }))}
                              />

                              <ErrorMessage
                                name="financialYear"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Data UOM <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Select
                                className="basic-single custom-select-style"
                                classNamePrefix="custom-select-style-inner"
                                onChange={(e) => {
                                  this.valueChange(e, "change_uom");
                                }}
                                value={{
                                  label: this.state.initialValues.dataUOMName,
                                  value: this.state.initialValues.dataUOMId,
                                }}
                                name="dataUomId"
                                options={["Per Month"].map((item) => ({
                                  label: item,
                                  value: item,
                                }))}
                              />

                              <ErrorMessage
                                name="dataUomId"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Cost Center
                            </label>
                            <div className="col-sm-7">
                              <input
                                className="basic-single"
                                name="costcenter"
                                // onInputChange={this.handleChange}
                                onChange={(e) => {
                                  //handleChange(e);
                                  console.log(e, "")
                                  this.state.initialValues.costCenter = e.target.value;
                                  this.setState({})
                                }}

                              />

                              <ErrorMessage
                                name="costCenter"
                                component="div"
                                className="text-red"
                              />
                              { }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>




                    <div className="row">
                      <div className="col-lg-6 offset-lg-6">
                        <div className="btnContainer">
                          <div>
                            <button type="submit" d1isabled={isSubmitting}>
                              View
                            </button>
                            <button type="reset" d1isabled={isSubmitting}>
                              Reset
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>


                  </div>
                </Form>
              </div> */}
            </>
          )}
        </Formik>
        <Formik
          initialValues={this.state.initialForecast}
          enableReinitialize
          onReset={(values, actions) => {
            this.setState({
              //formResponseData: data,
              initialForecast: this.state.formResponseData.forecasteDetails,
            });
          }}
          onSubmit={(values, actions) => {
            console.log("form submitting..", values);
            var self = this;
            var formPostData = {};

            formPostData["leaseId"] = this.state.initialForecast.leaseId;
            formPostData["year"] = this.state.initialForecast.year;
            formPostData["forecasteDetails"] = values.actual;

            console.log(formPostData, ":formPostData");
            axios({
              method: "post",
              url: `${apiUrl.apiUrl.url}/sales-input/create-input-sales`,
              data: formPostData,
            }).then(function (response) {
              if (!response.data.success) {
                actions.setSubmitting(false);
                actions.setErrors(response.data);
              } else {
                // alert("Data Saved Successfully");
                //self.setState({ redirect: true });
                self.setState({
                  messsagePopup: true,
                  popupContent: 'Data Saved Successfully'
                });
              }
            });
          }}
        >
          {({
            values,

            errors,

            touched,

            handleChange,

            handleBlur,

            handleSubmit,

            handleReset,

            isSubmitting,
          }) => (
            <div className="unitFormContainerNew unitFormContainerTable">
              <Form autoComplete="off">
                <div className="tableContainer reportsTable">
                  <table className="table tableSimple tableSimpleWithNoFlex">
                    <thead>
                      <tr>
                        <th rowSpan="2">S.No</th>
                        <th rowSpan="2">Asset Name</th>
                        <th rowSpan="2">Brand Name / Occupier Name</th>
                        <th rowSpan="2">Lease Id</th>
                        <th rowSpan="2">Cost Center</th>
                        <th rowSpan="2">Gross Leasable Area</th>
                        <th rowSpan="2">Period</th>
                        <th rowSpan="1">Gross Sale</th>
                        <th rowSpan="1">Net Sale</th>
                      </tr>
                      <tr>
                        <th colSpan="2">Actual</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.formResponseData.forecasteDetails.actual.map(
                        (anObjectMapped, index) => {
                          return (
                            // <div> {anObjectMapped.leaseDocumentType} </div>
                            <tr>
                              <td>{index + 1}</td>
                              <td>
                                {this.state.formResponseData.assetName}
                              </td>
                              <td>
                                {this.state.formResponseData.brandName}
                              </td>
                              <td>
                                {this.state.formResponseData.leaseName}
                              </td>
                              <td>
                                {this.state.formResponseData.costCenter}
                              </td>
                              <td>
                                {
                                  this.state.formResponseData
                                    .grossLeasebleArea
                                }
                              </td>
                              <td>{anObjectMapped.periodFull}</td>

                              <td>
                                {anObjectMapped.inputStatus ? (
                                  <Field
                                    type="tnumberext"
                                    name={
                                      "actual." +
                                      index +
                                      ".actual_gross_sale"
                                    }
                                    //value={anObjectMapped.forecast_gross_sale}
                                    className="tdInput"
                                  />
                                ) : (
                                  <Field
                                    type="number"
                                    readonly="readonly"
                                    name={
                                      "actual." +
                                      index +
                                      ".actual_gross_sale"
                                    }
                                    className="tdInput"
                                  />
                                )}
                              </td>
                              <td>
                                {anObjectMapped.inputStatus ? (
                                  <Field
                                    type="tnumberext"
                                    name={
                                      "actual." +
                                      index +
                                      ".actual_net_sale"
                                    }
                                    //value={anObjectMapped.forecast_net_sale}
                                    className="tdInput"
                                  />
                                ) : (
                                  <Field
                                    type="number"
                                    readonly="readonly"
                                    name={
                                      "actual." +
                                      index +
                                      ".actual_net_sale"
                                    }
                                    className="tdInput"
                                  />
                                )}
                              </td>
                            </tr>
                          );
                        }
                      )}

                      {this.state.formResponseData.forecasteDetails.actual
                        .length == 0 && (
                          <tr>
                            <td colSpan="8" className="text-center"> Nothing to show.....</td>
                          </tr>
                        )}
                    </tbody>
                  </table>
                  {this.state.formResponseData.forecasteDetails.actual
                    .length > 0 && (
                      <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                        <button type="submit" d1isabled={isSubmitting} className="add_button">
                          Save
                        </button>
                        <button type="reset" d1isabled={isSubmitting} onClick={handleReset} className="reset_button">
                          Reset
                        </button>
                      </div>
                    )}
                </div>
              </Form>
              <PopupMessage
                open={this.state.messsagePopup}
                content={this.state.popupContent}
                redirectAfterSave={this.redirectAfterSave}
              />
              <Popup open={this.state.popupalertMessage} position="top center">
                {(close) => (
                  <div>
                    {this.state.popupMessageContent}
                    <a className="close" onClick={this.redirectToClose}>
                      &times;
                    </a>
                  </div>
                )}
              </Popup>
            </div>
          )}
        </Formik>

        {this.state.exportBtn && (
          <Formik
            validationSchema={uploadFromFrm}
            initialValues={this.state.initialValues}
            enableReinitialize
            onSubmit={(values, actions) => {
              values.leaseDocumentUrl =
                fileUploadPath() +
                this.props.match.params.id +
                "/" +
                this.state.fileName;
              console.log(values);
              var self = this;
            }}
          >
            {({
              values,

              errors,

              touched,

              handleChange,

              handleBlur,

              handleSubmit,

              isSubmitting,
            }) => (
              <Form autoComplete="off" className="customTabs">
                <div className="unitFormContainer leaseSection utilities">
                  <div className="container">
                    <div className="row">
                      <a href={this.state.exportUrl} target="_blank">
                        <button type="button">
                          Export Data
                        </button>
                      </a>
                    </div>

                    <div className="row">
                      <div className="col-lg-6">
                        <div className="inputContainer customFileUpload col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <div className="col-sm-4">
                              <h6>
                                Upload Document
                                <span className="astrik">*</span>
                              </h6>
                            </div>
                            <div className="col-sm-7">
                              <Field
                                name="myfile"
                                type="file"
                                onChange={this.onFileChange}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-6 offset-lg-6">
                        <div className="btnContainer formSubmit">
                          <div>
                            <button onClick={this.onFileUpload}>Upload</button>

                            <button type="reset">
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="container utilities">
                  <div className="row">
                    <div className="tableContainer"></div>
                  </div>
                  <div className="row"></div>
                </div>
              </Form>
            )}
          </Formik>
        )}

        {/* <Table
          key={this.state.counter}
          clikekey={
            this.state.selectedBrand +
            "--" +
            this.state.selectedAsset +
            "--" +
            this.state.initialValues.cityId
          }
          asset={this.state.selectedAsset}
          formConfig={this.state.formConfig}
          brand={this.state.selectedBrand}
          expiry_report="true"
          columns={this.state.gridColumns}
        /> */}
      </div>
    );
  }
}

export default withRouter(LeaseReportSalesActual);
